import Vue from "vue";
export const GlobalEventBus = new Vue();
